namespace Nobox.Web.Modules.Attr.Enum {
    export enum EmailQueuePriority {
        High = 1,
        Medium = 2,
        Low = 3
    }
    Serenity.Decorators.registerEnumType(EmailQueuePriority, 'Nobox.Web.Modules.Attr.Enum.EmailQueuePriority');
}
